import React, {useCallback, useEffect, useState} from 'react';
import CurrencyNumber from '../../../cmp/CurrencyNumber';
import {get} from '../../../../api';
import FormattedNumber from '../../../cmp/FormattedNumber';
import {useSelector} from 'react-redux'
import {FormattedMessage, FormattedDate} from 'react-intl'
import dayjs from '../../../../mydayjs';
import Skeleton from 'react-loading-skeleton'
import {NextIcon, PreviousIcon} from '../../../../icons/Icons';
export default function RenderCustomLeaderboards(){
  const custom_leaderboards = useSelector((state)=>state.settings.custom_leaderboards);
  return <>
    {
      custom_leaderboards ? custom_leaderboards.map((i)=>{
        return <RenderCustomLeaderboard
            timePeriodX={i.timePeriodX}
            key={i.id} id={i.id} timePeriod={i.timePeriod} name={i.name} />
      }) : null
    }
  </>
}


function RenderTimePeriod({timePeriod, timePeriodX, offset}){
  switch (timePeriod){
    case "year":
      return <FormattedDate value={dayjs().subtract(offset || 0, 'year').toDate()}
                            year={"numeric"}/>
    case "month":
      return <FormattedDate value={dayjs().subtract(offset || 0, 'month').toDate()} year={"numeric"} month={"long"}/>
    case "quarter":{
      const d = dayjs().subtract(offset || 0, 'quarter')
      return <><FormattedDate value={d.startOf('quarter').toDate()} month={"short"} /> - <FormattedDate value={d.endOf('quarter').toDate()} month={"short"}/></>
    }
    case "day":{
      return <FormattedDate value={dayjs().subtract(offset || 0, 'day').toDate()}
                            year={"numeric"} month={"short"} day={"2-digit"}/>
    }
    case "lastXDays":
      return <span>
        <FormattedDate value={dayjs().subtract(((offset || 0)+1) * timePeriodX, 'day').toDate()}  year={"numeric"} month={"short"} day={"numeric"}/> -
        <FormattedDate value={dayjs().subtract((offset || 0) * timePeriodX, 'day').toDate()}  year={"numeric"} month={"short"} day={"numeric"} />
      </span>
    case "all":
      return <FormattedMessage id={"All time"}/>
    default:
      return null;

  }
}


function RenderCustomLeaderboard({id, name, timePeriodX, timePeriod}) {
  const affiliate_id = useSelector((state)=>state.settings.affiliate_id)
  const [offset, setOffset] = useState(0)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(()=>{
    setLoading(true)
    get('/analytics/leaderboard/'+id,{
          offsetPeriod:offset,
    }).then((data)=>{
          setLoading(false)
          setData(data)
    })
  },[id, offset])
  const goPrevious = useCallback(()=>{
    setOffset((x)=>x+1)
  },[])
  const goNext = useCallback(()=>{
    setOffset((x)=>x-1)
  },[])
  if(!data) return null;
  return (
      <>
        <div className="card">
          <div className="card-body">
            <div className="card-title text-center">{name}</div>
            <div className={"d-flex align-items-center justify-content-between"}>
              <div style={{width:40}}>
                <button onClick={goPrevious} className={"btn p-0 text-left w-100"}><PreviousIcon /></button>
              </div>
              <RenderTimePeriod timePeriod={timePeriod} timePeriodX={timePeriodX} offset={offset} />
              <div style={{width:40}}>
                {offset > 0 ?
                    <button onClick={goNext}  className={"btn p-0 text-right w-100"}><NextIcon /></button>
                    : null
                }
              </div>

            </div>
            <hr/>
            {
              loading ? <Skeleton height={67.5}/> :
                  <>
                    <small className="text-muted">
                      <FormattedMessage id={'Your rank'} />
                    </small>
                    <div className="display-4" title={"Your rank"}>{data.me.rank}</div>
                    </>
            }
          </div>
          {
            loading ? <Skeleton height={48.5} count={5}/> :
                <ul className="list-group list-group-flush">

                  {
                    data.otherAffiliates.map((i) => {
                      return <li
                          key={String(i.affiliate_id)}
                          className="list-group-item d-flex align-items-center justify-content-between">
                        <div>
                          <strong
                              className={"d-inline-block mr-2"}>#{i.rank}</strong>
                          <span>{i.affiliate_id == affiliate_id ?
                              <span className={"text-info"}><FormattedMessage id={"You"}/></span> :
                              i.affiliate.name}</span>
                        </div>
                        {
                          i.value ? <>
                            {
                              i.dataType === "currency" ?
                                  <CurrencyNumber value={i.value}/> :
                                  <FormattedNumber value={i.value}/>
                            }                    </> : null
                        }
                      </li>
                    })
                  }
                </ul>
          }
        </div>
      </>
  );
}


